import { useContext } from 'react';
import { InitialDataContext } from './context';
import { InitialDataContextValue } from './types';

/**
 * Hook to use the InitialDataContext
 *
 * @returns The context value containing initial data, loading state, and error state
 * @throws Error if used outside of InitialDataProvider
 */
const useInitialData = (): InitialDataContextValue => {
    const context = useContext(InitialDataContext);
    if (context === undefined) {
        throw new Error('useInitialData must be used within an InitialDataProvider');
    }
    return context;
};

export default useInitialData;
